/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { incidenciasTecnicasControllerEnviarIncidenciaTecnica } from '../fn/paciente-incidencias-tecnicas/incidencias-tecnicas-controller-enviar-incidencia-tecnica';
import { IncidenciasTecnicasControllerEnviarIncidenciaTecnica$Params } from '../fn/paciente-incidencias-tecnicas/incidencias-tecnicas-controller-enviar-incidencia-tecnica';

@Injectable({ providedIn: 'root' })
export class PacienteIncidenciasTecnicasService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `incidenciasTecnicasControllerEnviarIncidenciaTecnica()` */
  static readonly IncidenciasTecnicasControllerEnviarIncidenciaTecnicaPath = '/api/incidencias-tecnicas/enviar-incidencia-tecnica';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `incidenciasTecnicasControllerEnviarIncidenciaTecnica()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  incidenciasTecnicasControllerEnviarIncidenciaTecnica$Response(params: IncidenciasTecnicasControllerEnviarIncidenciaTecnica$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return incidenciasTecnicasControllerEnviarIncidenciaTecnica(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `incidenciasTecnicasControllerEnviarIncidenciaTecnica$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  incidenciasTecnicasControllerEnviarIncidenciaTecnica(params: IncidenciasTecnicasControllerEnviarIncidenciaTecnica$Params, context?: HttpContext): Observable<void> {
    return this.incidenciasTecnicasControllerEnviarIncidenciaTecnica$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
